module.exports = __webpack_public_path__ + "static/media/story_bg_white.536f2b9a.png";